
export enum ELuceneLogic {
  AND = 'and',
  OR = 'or',
  NOT = 'not',
  INCLUDE = '+',
  EXCLUDE = '-',
}
